import { jsxs, jsx } from 'react/jsx-runtime';
import styled from 'styled-components';
import ndsTokens from 'nicollet-tokens';
import { Link as StyledLink$1 } from '../../Link/index.js';

const Wrapper = styled.div.attrs({
  id: 'footer-links'
})`
  font-size: ${ndsTokens.font.size.text.medium};
`;
const Items = styled.ul`
  list-style: none outside none;
  margin: 0;
  padding: 0;
`;
const Item = styled.li`
  display: inline-block;
  margin-right: ${ndsTokens.space.generic.x2};
  font-size: ${ndsTokens.font.size.text.small};
  &:last-child {
    margin-right: 0;
  }
`;
const PrivacyUpdatedItem = styled(Item)`
  font-weight: bold;
  color: ${ndsTokens.colors.messaging.promotion};
`;
const StyledLink = styled(StyledLink$1).attrs({
  underline: 'never'
})`
  text-decoration: none;
  color: ${ndsTokens.colors.text.onLight.primary};
  font-size: ${ndsTokens.font.size.text.small};
`;
const LinksSection = ({
  links = [],
  privacyUpdatedDate,
  copyrightYear,
  ...rest
}) => jsxs(Wrapper, Object.assign({}, rest, {
  children: [links && links.length > 0 && jsxs(Items, {
    children: [links.map(({
      name,
      href,
      lnk,
      ...restLinkProps
    }) => jsx(Item, {
      children: jsx(StyledLink, Object.assign({
        "data-lnk": lnk,
        href: href
      }, restLinkProps, {
        children: name
      }), void 0)
    }, `${name}-${href}`)), privacyUpdatedDate && jsxs(PrivacyUpdatedItem, {
      children: ["Privacy updated ", privacyUpdatedDate]
    }, void 0)]
  }, void 0), jsx(Items, {
    children: jsxs(Item, {
      children: ["\u2122 & \u00A9 ", copyrightYear, " Target Brands, Inc."]
    }, void 0)
  }, void 0)]
}), void 0);
LinksSection.displayName = 'LinksSection';

export { LinksSection };
